<template>
  <vue-qr
    :logo-src="logoSrc"
    :text="url"
    :margin="10"
    :size="600"
    style="width: 120px; height: 120px"
    :logo-scale="0.15"
  ></vue-qr>
</template>

<script>
import VueQr from 'vue-qr'
import { logoSrc } from 'dygc'

export default {
  name: 'Qr',
  components: { VueQr },
  props: {
    url: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      logoSrc
    }
  }
}
</script>

<style scoped></style>
